import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AppContext, FeatureContext, UserContext } from "./App";
import { Chevron } from "./icons/Chevron";
import layoutStyles from "./Layout.module.css";
import styles from "./Menu.module.css";
import { ReactComponent as Logo } from "./resources/configura.svg";

export function Menu() {
	const features = useContext(FeatureContext);
	const general = useContext(AppContext);
	const user = useContext(UserContext);
	const [initials, setInitials] = useState("");
	const [expanded, setExpanded] = useState(false);
	const [error, setError] = useState<Option<string>>(undefined);
	const navigate = useNavigate();

	useEffect(() => {
		let initials = "";
		if (user && user.name) {
			initials = user.name
				.split(" ")
				.reduce((prev, current, index) => prev + current[0], initials)
				.slice(0, 2)
				.toUpperCase();
		}
		setInitials(initials);
	}, [user]);

	async function handleLogout() {
		if (general) {
			const res = await general.logout();
			if (res instanceof Error) {
				setError(res.message);
				return;
			}
			navigate("/");
		}
	}

	return (
		<div className={layoutStyles.homeContainer}>
			<div className={layoutStyles.homeContent}>
				<nav className={styles.menu}>
					<div className={styles.menuFront}>
						<Link to="/">
							<Logo className={styles.configuraLogo} />
						</Link>
					</div>
					<div className={styles.menuBack}>
						<NavLink
							className={({ isActive }) =>
								isActive ? styles.menuLinkActive : styles.menuLink
							}
							to="/catalogue"
						>
							Catalogue
						</NavLink>
						<NavLink
							className={({ isActive }) =>
								isActive ? styles.menuLinkActive : styles.menuLink
							}
							to="/cmsym-viewer"
						>
							CmSym Viewer
						</NavLink>

						<div className={styles.dropdownWrapper}>
							<button
								aria-haspopup="true"
								aria-expanded={expanded}
								className={styles.dropdownButton}
								onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
									e.preventDefault();
									setExpanded((prev) => !prev);
								}}
								type="button"
							>
								<div
									className={`${styles.initials} ${
										expanded ? styles.initialsActive : ""
									}`}
								>
									{initials}
								</div>
								<span aria-hidden="true" className={styles.dropdownIcon}>
									<Chevron up={expanded} />
								</span>
							</button>
							{expanded && (
								<div className={styles.dropdown}>
									{features.includes("superuser") && (
										<Link className={styles.dropdownItem} to="/admin">
											Admin
										</Link>
									)}
									<Link className={styles.dropdownItem} to="/settings">
										Settings
									</Link>
									<button className={styles.dropdownItem} onClick={handleLogout}>
										Log out
									</button>
								</div>
							)}
						</div>
					</div>
				</nav>
				{error !== undefined && <div>{error}</div>}
			</div>
		</div>
	);
}
